import type { Template } from "@/types";

export const PO_02_H0_V2: Template[] = [

    {
        id: "po-02-h0v2-01",
        name: "PO 01 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_01.png",
        size: [1136, 854],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 },
            { id: "2", x: 648, y: 81, width: 408, height: 692, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-02",
        name: "PO 02 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_02.png",
        size: [1136, 854],
        style: {},
        slots: [
            { id: "1", x: 208, y: 127, width: 355, height: 601, rotation: 0, imageRotation: 0 },
            { id: "2", x: 573, y: 127, width: 355, height: 601, rotation: 0, imageRotation: 0 }
        ],
    },
{
    id: "po-02-h0v2-03",
    name: "PO 03 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_03.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 647, y: 81, width: 408, height: 692, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 81, width: 408, height: 692, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-04",
    name: "PO 04 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_04.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 208, y: 127, width: 355, height: 601, rotation: 0, imageRotation: 0 },
            { id: "2", x: 573, y: 127, width: 355, height: 601, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-05",
    name: "PO 05 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_05.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 31, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 },
            { id: "2", x: 600, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-06",
    name: "PO 06 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_06.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 31, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 },
            { id: "2", x: 701, y: 171, width: 302, height: 512, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-07",
    name: "PO 07 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_07.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 68, y: 61, width: 432, height: 733, rotation: 0, imageRotation: 0 },
            { id: "2", x: 701, y: 171, width: 302, height: 512, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-08",
    name: "PO 08 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_08.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 107, y: 127, width: 355, height: 601, rotation: 0, imageRotation: 0 },
            { id: "2", x: 675, y: 127, width: 355, height: 601, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-09",
    name: "PO 09 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_09.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 601, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 171, width: 302, height: 512, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-10",
    name: "PO 10 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_10.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 637, y: 61, width: 432, height: 733, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 171, width: 302, height: 512, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-11",
    name: "PO 11 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_11.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 92, y: 101, width: 385, height: 653, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 101, width: 385, height: 653, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-12",
    name: "PO 12 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_12.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 31, y: 34, width: 504, height: 788, rotation: 0, imageRotation: 0 },
            { id: "2", x: 599, y: 34, width: 504, height: 788, rotation: 0, imageRotation: 0 }
    ],
}
];